import React, { useEffect, useState } from "react";
import * as Icons from "react-feather";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../store/auth";
import { fallbackFestival } from "lib/festivalConfig";
import { festivalOptionLabel } from "./FestivalSwitcher";
import { IconLoader, isItemActive } from "./SideBar";

export default function MobileMenu({
  festival = fallbackFestival,
  festivals = [],
  busy = false,
  error = "",
  onFestivalChange = () => undefined,
}) {
  const [showMenu, setShowMenu] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState("");
  const location = useLocation();
  const auth = useAuth();
  const menus = (auth.userMeta?.panel_menus || []).filter((item) => item.allow);

  useEffect(() => {
    setShowMenu(false);
    const matched = menus.find((item) => isItemActive(location.pathname, item));
    setExpandedMenu(matched?.to || "");
    // Auth menus are stable during navigation; the route is the close/update trigger.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <div className="mobile-menu md:hidden">
      <div className="mobile-menu-bar">
        <Link to="/dashboard" className="flex ml-auto" aria-label="داشبورد">
          <img alt={festival.name} className="h-8 w-28 object-contain" src={festival.logo} />
        </Link>
        <button
          type="button"
          id="mobile-menu-toggler"
          onClick={() => setShowMenu((current) => !current)}
          aria-label={showMenu ? "بستن منو" : "باز کردن منو"}
          aria-expanded={showMenu}
        >
          {showMenu ? (
            <Icons.X aria-hidden="true" className="h-8 w-8 text-white" />
          ) : (
            <Icons.Menu aria-hidden="true" className="h-8 w-8 text-white" />
          )}
        </button>
      </div>

      <ul className={`border-t border-theme-29 py-5 ${showMenu ? "" : "hidden"}`}>
        <li className="px-4 pb-4 text-white">
          <label className="flex flex-col gap-2" htmlFor="active-festival-selector-mobile">
            جشنواره فعال
            <select
              id="active-festival-selector-mobile"
              className="rounded border-0 bg-theme-1 px-2 py-2"
              value={festival.slug}
              disabled={busy}
              onChange={(event) => onFestivalChange(event.target.value)}
            >
              {(festivals.length ? festivals : [festival]).map((item) => (
                <option key={item.slug} value={item.slug}>
                  {festivalOptionLabel(item, festival.slug)}
                </option>
              ))}
            </select>
          </label>
          <Link className="mt-2 block text-sm text-white text-opacity-75" to="/settings/festivals">
            مدیریت جشنواره‌ها
          </Link>
          {error ? (
            <span className="mt-1 block text-red-200" role="alert">
              {error}
            </span>
          ) : null}
        </li>

        {menus.map((item) => {
          const children = (item.childs || []).filter((child) => child.allow);
          const active = isItemActive(location.pathname, item);
          const expanded = expandedMenu === item.to;

          return (
            <li key={item.to || item.title}>
              {children.length ? (
                <button
                  type="button"
                  onClick={() => setExpandedMenu((current) => (current === item.to ? "" : item.to))}
                  className={`menu w-full text-right ${active ? "menu--active" : ""}`}
                  aria-expanded={expanded}
                >
                  <span className="menu__icon">
                    <IconLoader name={item.icon} />
                  </span>
                  <span className="menu__title">
                    {item.title}
                    <Icons.ChevronDown
                      aria-hidden="true"
                      className={`menu__sub-icon transition-transform ${expanded ? "rotate-180" : ""}`}
                    />
                  </span>
                </button>
              ) : (
                <Link to={item.to} className={`menu ${active ? "menu--active" : ""}`}>
                  <span className="menu__icon">
                    <IconLoader name={item.icon} />
                  </span>
                  <span className="menu__title">{item.title}</span>
                </Link>
              )}

              {children.length ? (
                <ul className={expanded ? "menu__sub-open" : ""}>
                  {children.map((child) => (
                    <li key={child.to || child.title}>
                      <Link to={child.to} className={`menu ${isItemActive(location.pathname, child) ? "menu--active" : ""}`}>
                        <span className="menu__icon">
                          <IconLoader name={child.icon} />
                        </span>
                        <span className="menu__title">{child.title}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
